import { Dispatch } from 'redux';
import { axiosInstance, request, requestConfig } from './base';
import {
  NotificacaoConfiguracaoRequest,
  NotificacaoConfiguracaoResponse,
  AtualizarNotificacaoConfiguracaoRequest,
} from 'common/genericTypes';

export const GETNotificacaoConfiguracoes = async (
  dispatch: Dispatch,
  participanteId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<NotificacaoConfiguracaoResponse[]>(
        `${requestConfig.api}api/v1/participantes/${participanteId}/notificacoes/configuracoes`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTNotificacaoConfiguracao = async (
  dispatch: Dispatch,
  participanteId: string,
  configuracao: NotificacaoConfiguracaoRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<NotificacaoConfiguracaoResponse>(
        `${requestConfig.api}api/v1/participantes/${participanteId}/notificacoes/configuracoes`,
        configuracao
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTNotificacaoConfiguracao = async (
  dispatch: Dispatch,
  configuracaoId: string,
  configuracao: AtualizarNotificacaoConfiguracaoRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.put<NotificacaoConfiguracaoResponse>(
        `${requestConfig.api}api/v1/participantes/notificacoes/configuracoes/${configuracaoId}`,
        configuracao
      ),
    dispatch,
    undefined,
    stackRequest
  );
};
